module.exports = __webpack_public_path__ + "static/boat1-ea97d07e9a996640655c749c7f4a3a11.jpg";